import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private config: PrimeNGConfig) {}


  ngOnInit() {
    /*this.config.setTranslation({
      dayNames: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
      dayNamesShort: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
      dayNamesMin: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
      monthNames: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
      monthNamesShort: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
      today: 'Dnes',
      clear: 'Reset'
    });*/

    this.config.setTranslation({
        startsWith: $localize`Starts with`,
        contains: $localize`Contains`,
        notContains: $localize`Not contains`,
        endsWith: $localize`Ends with`,
        equals: $localize`Equals`,
        notEquals: $localize`Not equals`,
        noFilter: $localize`No Filter`,
        lt: $localize`Less than`,
        lte: $localize`Less than or equal to`,
        gt: $localize`Greater than`,
        gte: $localize`Greater than or equal to`,
        is: $localize`Is`,
        isNot: $localize`Is not`,
        before: $localize`Before`,
        after: $localize`After`,
        dateIs: $localize`Date is`,
        dateIsNot: $localize`Date is not`,
        dateBefore: $localize`Date is before`,
        dateAfter: $localize`Date is after`,
        clear: $localize`Clear`,
        apply: $localize`Apply`,
        matchAll: $localize`Match All`,
        matchAny: $localize`Match Any`,
        addRule: $localize`Add Rule`,
        removeRule: $localize`Remove Rule`,
        accept: $localize`Yes`,
        reject: $localize`No`,
        choose: $localize`Choose`,
        upload: $localize`Upload`,
        cancel: $localize`Cancel`,
        dayNames: [$localize`Sunday`, $localize`Monday`, $localize`Tuesday`, $localize`Wednesday`, $localize`Thursday`, $localize`Friday`, $localize`Saturday`],
        dayNamesShort: [$localize`Sun`, $localize`Mon`, $localize`Tue`, $localize`Wed`, $localize`Thu`, $localize`Fri`, $localize`Sat`],
        dayNamesMin: [$localize`Su`,$localize`Mo`,$localize`Tu`,$localize`We`,$localize`Th`,$localize`Fr`,$localize`Sa`],
        monthNames: [$localize`January`,$localize`February`,$localize`March`,$localize`April`,$localize`May`,$localize`June`,$localize`July`,$localize`August`,$localize`September`,$localize`October`,$localize`November`,$localize`December`],
        monthNamesShort: [$localize`Jan`, $localize`Feb`, $localize`Mar`, $localize`Apr`, $localize`May`, $localize`Jun`,$localize`Jul`, $localize`Aug`, $localize`Sep`, $localize`Oct`, $localize`Nov`, $localize`Dec`],
        dateFormat: 'dd.mm.yy',
        firstDayOfWeek: 1,
        today:$localize`Today`,
        weekHeader: $localize`Wk`,
        weak: $localize`Weak`,
        medium: $localize`Medium`,
        strong: $localize`Strong`,
        passwordPrompt: $localize`Enter a password`,
        emptyMessage: $localize`No results found`,
        emptyFilterMessage: $localize`No results found`
    });
}
}
